export default __webpack_public_path__ + "static/media/login-bg.f66a554d.png";